import { createSlice } from '@reduxjs/toolkit';
import { createTrigger, deleteQuery, getAllTriggers, getDataInputs, getQueryPreview, getTriggerById, updateTriggerById } from '../thunks/triggerThunk';
import { toast } from 'react-toastify';

const querySlice = createSlice({
    name: 'query',
    initialState: {
        isLoading: true,
        allTriggers: [],
        dataInputs: [],
        preview: [],
        query:{},
        total_preview: "0",
        showModal: false,
        title: "Create new query",
        selected: [],
        selectAll: false,
        isChanged: 0,
        isTableLoading: true,
    },
    reducers: {
        handleQueryModal(state, action) {
            const { title } = action.payload;
            let newState = { ...state };
        
            if (title === "Create new query") {
              newState.query = {};
              newState.preview = [];
              newState.total_preview = "0";
            }
            newState.selected = [];
            newState.selectAll = false;
            newState.showModal = !state.showModal;
            newState.title = title;
        
            return newState;
          },
          handleSelected(state, action) {
            let updatedSelected = [];
        
            if (action.payload.type === 'SET_SELECTED_ROWS') {
                const selectedId = action.payload.selectedId;
                const isSelected = state.selected.includes(selectedId);
        
                if (isSelected) {
                    updatedSelected = state.selected.filter(id => id !== selectedId);
                } else {
                    updatedSelected = [...state.selected, selectedId];
                }
            }
        
            if (action.payload.type === 'SELECT_ALL') {
                updatedSelected = state.selectAll ? [] : (state.allTriggers || []).map((row) => row.id);
            }
        
            const selectAll = state.allTriggers.length === updatedSelected.length;
        
            return {
                ...state,
                selected: updatedSelected,
                selectAll,
            };
        },
        setSelectAllFalse(state, action){
            return {
                ...state,
                selectAll: false,
              };
        },
        resetQueryData(state, action){
            state.query = {};
            state.total_preview="0";
        }
        
        
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllTriggers.fulfilled, (state, action) => {
                state.isTableLoading = false;
                if(action.payload?.status_code){
                    state.allTriggers = action.payload?.triggers || [];
                }
                else{
                    state.allTriggers = [];
                    toast.error(action.payload?.error);
                }
            })
            .addCase(getAllTriggers.pending, (state, action) => {
                state.isTableLoading = true;
                state.error = null;
            })
            .addCase(getAllTriggers.rejected, (state, action) => {
                state.isTableLoading = false;
                state.error = action.payload;
                state.allTriggers = [];
                toast.error(action.payload);
            })
            .addCase(getDataInputs.fulfilled, (state, action) => {
                state.isLoading = false;
                if(action.payload?.status_code){
                    state.dataInputs = action.payload?.groups || [];
                }
                else{
                    toast.error(action.payload?.error);
                }
            })
            .addCase(getDataInputs.pending, (state, action) => {
                state.isLoading= true;
                state.error = null;
            })
            .addCase(getDataInputs.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(getQueryPreview.fulfilled, (state, action) => {
                state.isLoading = false;
                if(action.payload?.status_code){
                    state.preview = action.payload?.results?.physicians|| [];
                    state.total_preview = action.payload?.results?.total_results?.toString();
                }
                else{
                    toast.error(action.payload?.error);
                }
            })
            .addCase(getQueryPreview.pending, (state, action) => {
                state.isLoading= true;
                state.error = null;
            })
            .addCase(getQueryPreview.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(getTriggerById.fulfilled, (state, action) => {
                state.isLoading = false;
                if(action.payload?.status_code){
                    state.query = action.payload?.trigger || {};
                }
                else{
                    toast.error(action.payload?.error);
                }
            })
            .addCase(getTriggerById.pending, (state, action) => {
                state.isLoading= true;
                state.error = null;
            })
            .addCase(getTriggerById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(createTrigger.fulfilled, (state, action) => {
                state.isLoading = false;
                if(action.payload?.status_code === 200){
                    toast.success(action.payload?.success)
                    state.isChanged+= 1;
                }
                else{
                    toast.error(action.payload?.error);
                }
            })
            .addCase(createTrigger.pending, (state, action) => {
                state.isLoading= true;
                state.error = null;
            })
            .addCase(createTrigger.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload?.error?.definitions?.toString());
            })
            .addCase(updateTriggerById.fulfilled, (state, action) => {
                state.isLoading = false;
                if(action.payload?.status_code === 200){
                    toast.success(action.payload?.success)
                    state.isChanged+= 1;
                }
                else{
                    toast.error(action.payload?.error);
                }
            })
            .addCase(updateTriggerById.pending, (state, action) => {
                state.isLoading= true;
                state.error = null;
            })
            .addCase(updateTriggerById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(deleteQuery.fulfilled, (state, action) => {
                state.isLoading = false;
                if(action.payload?.status_code){
                    toast.success(action.payload?.success)
                    state.isChanged+= 1;
                }
                else{
                    toast.error(action.payload?.error);
                }
            })
            .addCase(deleteQuery.pending, (state, action) => {
                state.isLoading= true;
                state.error = null;
            })
            .addCase(deleteQuery.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
    },
});

const getSelectedForField = (dataInputs,value) => {
    let selected = null;

        if (value !== '') {
            dataInputs?.map(group => {
                group.options.map(option => {
                    if (option.value === value) {
                        selected = option;
                    }
                });
            });
        }
        return selected;
}

export {getSelectedForField};
export const actions = querySlice.actions;
export default querySlice.reducer;
